import axiosInstance from "./axios";

export class SedeService {
    getSedes() {
        return axiosInstance
            .get("/sede")
            .then((res) => res.data)
    }

    addSede(dto) {
        return axiosInstance
            .post("/sede", dto)
            .then((res) => res.data)
    }

    updateSede(dto) {
        return axiosInstance
            .put(`/sede/${dto._id}`, dto)
            .then((res) => res.data)
    }

    deleteSede(id) {
        return axiosInstance
            .delete(`/sede/${id}`)
            .then((res) => res.data)
    }
}
